import React from 'react';
import styled from 'styled-components';

import { LoaderIcon } from '~/atomic/atom/icon/LoaderIcon';
import Modal from '~/atomic/molecula/Modal';
import { PageTitleStyle, TextRegStyle } from '~/atomic/Typography';
import { paymentResultSelector } from '~/feature/book/paymentResult/paymentResult.selector';
import { paymentResultActions } from '~/feature/book/paymentResult/paymentResult.slice';
import { useAppDispatch, useAppSelector } from '~/store';

export const TransactionLoader = () => {
  const dispatch = useAppDispatch();
  const { isOpenTransactionLoader } = useAppSelector(paymentResultSelector);

  const closeModalHandler = () => {
    dispatch(paymentResultActions.setIsOpenTransactionLoader(false));
  };

  return (
    <SCModal
      open={isOpenTransactionLoader}
      onCancel={closeModalHandler}
    >
      <SCWrapper>
        <SCLoaderIcon />
        <SCTextWrapper>
          <SCTitle>
            Банк обрабатывает платеж...
          </SCTitle>
          <SCDescription>
            Пожалуйста, не закрывайте эту страницу.
          </SCDescription>
        </SCTextWrapper>
      </SCWrapper>
    </SCModal>
  );
};

const SCModal = styled(Modal)`
  max-width: 540px;
  width: 100% !important;

  .ant-modal-body {
    padding: 20px 16px;
  }
`;

const SCWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const SCLoaderIcon = styled(LoaderIcon)`
  max-width: 50px;
`;

const SCTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const SCTitle = styled.span`
  ${PageTitleStyle};
`;

const SCDescription = styled.span`
  ${TextRegStyle};
`;

const SCLink = styled(SCDescription)`
  color: var(--primary-color);
`;
